import React from 'react';
import { ChevronDown, Sparkles } from 'lucide-react';
import { salonInfo } from '../data/mock';

export const HeroSection = () => {
  const scrollToServices = () => {
    const element = document.querySelector('#services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsApp = () => {
    const message = `¡Hola! Me gustaría agendar una cita en ${salonInfo.name}.`;
    const whatsappUrl = `https://wa.me/${salonInfo.whatsapp.replace(/\+/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen overflow-hidden bg-neutral-900"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=1920&q=80"
          alt="Spa ambiente"
          className="h-full w-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
      </div>

      {/* Gold accent lines */}
      <div className="absolute left-0 top-1/3 h-px w-32 bg-gradient-to-r from-transparent to-[#d4af37]/50" />
      <div className="absolute right-0 top-2/3 h-px w-32 bg-gradient-to-l from-transparent to-[#d4af37]/50" />

      {/* Decorative Elements */}
      <div className="absolute left-10 top-1/4 h-64 w-64 rounded-full bg-[#d4af37]/5 blur-3xl" />
      <div className="absolute bottom-1/4 right-10 h-80 w-80 rounded-full bg-[#d4af37]/5 blur-3xl" />

      {/* Content */}
      <div className="relative flex min-h-screen flex-col items-center justify-center px-4 text-center">
        <div className="max-w-4xl">
          {/* Logo */}
          <div className="mb-8 flex justify-center">
            <img 
              src={salonInfo.logo} 
              alt="Saldívar Villar Logo" 
              className="h-32 w-32 rounded-full object-cover shadow-2xl border-4 border-[#d4af37]/30 md:h-40 md:w-40"
            />
          </div>

          {/* Badge */}
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#d4af37]/30 bg-black/30 px-4 py-2 backdrop-blur-sm">
            <Sparkles className="h-4 w-4 text-[#d4af37]" />
            <span className="text-sm font-medium text-[#d4af37]">Belleza & Bienestar</span>
          </div>

          {/* Main Title */}
          <h1 className="font-serif text-4xl font-bold leading-tight text-white sm:text-5xl md:text-6xl lg:text-7xl">
            {salonInfo.tagline}
          </h1>

          {/* Subtitle */}
          <p className="mx-auto mt-6 max-w-2xl text-lg text-neutral-300 sm:text-xl">
            {salonInfo.subtitle}
          </p>

          {/* Decorative line with gold */}
          <div className="mx-auto my-8 flex items-center justify-center gap-3">
            <div className="h-px w-20 bg-gradient-to-r from-transparent to-[#d4af37]/50" />
            <div className="h-2 w-2 rounded-full bg-[#d4af37]" />
            <div className="h-px w-20 bg-gradient-to-l from-transparent to-[#d4af37]/50" />
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            <button
              onClick={openWhatsApp}
              className="group relative overflow-hidden rounded-full bg-gradient-to-r from-[#d4af37] to-[#b8860b] px-8 py-4 text-lg font-semibold text-neutral-900 shadow-lg transition-all duration-300 hover:shadow-xl hover:shadow-[#d4af37]/20"
            >
              <span className="relative z-10">Agendar cita por WhatsApp</span>
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-[#f4e5c2] to-[#d4af37] transition-transform duration-300 group-hover:translate-x-0" />
            </button>
            <button
              onClick={scrollToServices}
              className="flex items-center gap-2 rounded-full border border-[#d4af37]/40 bg-black/30 px-8 py-4 text-lg font-medium text-white backdrop-blur-sm transition-all duration-300 hover:bg-[#d4af37]/10 hover:border-[#d4af37]"
            >
              Ver Servicios
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
          <button
            onClick={scrollToServices}
            className="flex animate-bounce flex-col items-center text-neutral-400 transition-colors hover:text-[#d4af37]"
          >
            <span className="mb-2 text-sm tracking-wider">Descubre más</span>
            <ChevronDown className="h-6 w-6" />
          </button>
        </div>
      </div>
    </section>
  );
};
